document.addEventListener('alpine:init', () => {
  Alpine.store('geolocation', {
    country: null,

    init() {
      fetch(`${ajaxurl}?action=get_geolocation`)
        .then((response) => response.json())
        .then((data) => {
          if (data.data) {
            this.country = data.data.toLowerCase();
          }
        });
    },
  });
});